{
  "build_id": "01bd075b207",
  "build_timestamp": 1783086014000,
  "environment": "prod",
  "version": "release-bw-tf-4.0.-4"
}
